import { gql } from 'graphql-request'

export const generateStripeOnboardingLinkMutation = gql`
  mutation GenerateStripeOnboardingLink($siteId: ID!) {
    generateStripeOnboardingLink(siteId: $siteId) {
      url
      expiresAt
    }
  }
`

export const generateStripeLoginLinkMutation = gql`
  mutation GenerateStripeLoginLink($siteId: ID!) {
    generateStripeLoginLink(siteId: $siteId)
  }
`
